import { combineReducers, configureStore } from "@reduxjs/toolkit";
import vpsReducer from "features/vps/vpsSlice";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "../features/common/auth/authSlice";
import cartReducer from "../features/common/layouts/cartSlice";
import stepReducer from "../features/common/layouts/stepSlice";
import productsReducer from "../features/common/products/productsSlice";
import diegoVpnReducer from "../features/diegoVpn/diegoVpnSlice";
import digitalSignatureReducer from "../features/digitalSignature/digitalSignatureSlice";
import domainReducer from "../features/domain/domainsSlice";
import emailSuiteReducer from "../features/emailSuite/emailSuiteSlice";
import hostingReducer from "../features/hosting/hostingSlice";
import sslReducer from "features/ssl/sslSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [
    "hosting",
    "vps",
    "domain",
    "emailSuite",
    "digitalSignature",
    "vpn",
    "auth",
    "products",
  ],
};

const reducer = combineReducers({
  auth: authReducer,
  products: productsReducer,
  hosting: hostingReducer,
  vps: vpsReducer,
  cart: cartReducer,
  domain: domainReducer,
  step: stepReducer,
  emailSuite: emailSuiteReducer,
  digitalSignature: digitalSignatureReducer,
  vpn: diegoVpnReducer,
  ssl: sslReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV === "development", // ! Development Only
});

export default store;
